























































import { Vue, Component, Ref } from 'vue-property-decorator'
import { date, format } from 'quasar'
import store from 'src/assets/store'
import ItemData from 'src/assets/ItemData'
import { StudentGradebook } from 'src/assets/AttendeeItemData'
import MessengerDialog from 'src/components/messenger/Messenger.vue'
import StudentButtonDelete from 'components/presenter/item/course/student/StudentButtonDelete.vue'
import StudentButtonBlock from 'components/presenter/item/course/student/StudentButtonBlock.vue'
import StudentButtonGroup from 'components/presenter/item/course/student/StudentButtonGroup.vue'
import StudentButtonEdit from 'components/presenter/item/course/student/StudentButtonEdit.vue'
import PersonAvatar from 'src/components/account/PersonAvatar.vue'
import StudentSessionsListItem from 'components/presenter/item/course/student/StudentSessionsListItem.vue'
import api from 'src/assets/api/gql'
import StudentGet from 'src/graphql/student/StudentGet.gql'
import { Item, Student, StudentGroup, SessionAttendee } from 'src/graphql/types'

@Component({
  components: {
    MessengerDialog,
    StudentButtonDelete,
    StudentButtonBlock,
    StudentButtonGroup,
    StudentButtonEdit,
    PersonAvatar,
    StudentSessionsListItem
  }
})
export default class PagePresenterItemCourseStudent extends Vue {
  state = store.state
  student: Student | null = null
  groups: StudentGroup[] = []
  topics: Map<number, Item> = new Map()
  gradebook: StudentGradebook | null = null

  get item () {
    return store.state.presenter.item
  }

  get group () {
    const studentGroupId = this.student?.studentGroupId
    return this.groups.find(g => g.id === studentGroupId)
  }

  get sessionsList () {
    const list = []
    if (this.gradebook) {
      for (const [id, topic] of this.topics) {
        const topicGradebook = this.gradebook.results[ id ]
        if (topicGradebook && topicGradebook.present) {
          for (const [attendeeId, attendeeResponseResult] of topicGradebook.results) {
            attendeeResponseResult.attendeeItemData.attendee.session.topic = topic
            list.push(attendeeResponseResult)
          }
        }
      }
    }
    return list
  }

  async refresh (done: () => void) {
    const { data: { itemChildren, student, studentGroups } } = await api.query({
      query: StudentGet,
      variables: {
        id: +this.$route.params.sid,
        courseId: +this.$route.params.cid || this.item.id
      }
    })
    if (student) {
      this.student = student
    } else {
      this.redirectToParent()
    }
    if (studentGroups) {
      this.groups = studentGroups.nodes as StudentGroup[]
    }
    if (itemChildren) {
      const topicsMap = new Map()
      const topics = itemChildren?.nodes || []
      for (const topic of topics) {
        topic.data = new ItemData(topic.dataGradebook || {})
        topicsMap.set(topic.id, topic)
      }
      this.topics = topicsMap
      this.gradebook = new StudentGradebook(this.topics, student.sessionAttendees.nodes as SessionAttendee[])
    }
    done()
  }

  async load (index: number, done: (stop?: boolean) => void) {
    done(true)
  }

  parentPath () {
    return '/presenter/'+this.item.id+'/students/'+(this.$route.params.cid || '')
  }

  redirectToParent () {
    this.$router.replace(this.parentPath())
  }
}
